module.exports = __webpack_public_path__ + "static/media/sf-trial-1-wrong.1d6ef901.mp3";